import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routeNodeSelector} from 'redux-router5';
import {Segment, Grid, Message} from 'semantic-ui-react';

import {invoiceActions, estimateActions} from 'actions';

import {setPopupTitle} from 'helpers';
import {Loading} from 'Common/Structure';
import InfoPanel from './components/InfoPanel';
import PaymentForm from './components/PaymentForm';

import './paymentCollection.scss';

const PaymentCollection = props => {
  const [estimate, setEstimate] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setPopupTitle('Pay');
  }, []);

  useEffect(() => {
    load();
  }, JSON.stringify(props.route.params));

  const load = async () => {
    const {params} = props.route;

    if (params.type && params.type.toLowerCase() === 'deposit') {
      const estimate = await props.loadEstimate(params.id);
      setEstimate(estimate);
    } else if (params.type && params.type.toLowerCase() === 'invoice') {
      const invoice = await props.loadInvoice(params.id);
      setInvoice(invoice);
    }
    setLoading(false);
  };

  if (loading) return <Loading />;

  const balanceDue = invoice ? invoice.balanceDue : estimate.depositDue;
  const amountPaid = invoice
    ? invoice.amountPaid || 0
    : estimate.depositPaid || 0;
  const anyBalance = balanceDue > 0;

  return (
    <Grid padded stackable>
      <Grid.Column width={anyBalance ? 11 : 16}>
        {!anyBalance &&
          (invoice || estimate) && (
            <Message
              header={`This ${invoice ? 'Invoice' : 'Estimate'} has ${
                amountPaid > 0 ? 'been paid' : 'no balance'
              }.`}
              icon={amountPaid === 0 ? 'info' : 'check'}
              info={amountPaid === 0}
              success={amountPaid > 0}
            />
          )}

        <Segment>
          <InfoPanel estimate={estimate} invoice={invoice} />
        </Segment>
      </Grid.Column>

      {anyBalance && (
        <Grid.Column width={5}>
          <PaymentForm
            balanceDue={balanceDue}
            estimate={estimate}
            invoice={invoice}
            paymentMethod={Number(props.route.params.method)}
          />
        </Grid.Column>
      )}
    </Grid>
  );
};

PaymentCollection.propTypes = {
  // functions
  loadEstimate: PropTypes.func.isRequired,
  loadInvoice: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    ...routeNodeSelector('paymentcollection')(state),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadEstimate: estimateActions.loadEstimate,
      loadInvoice: invoiceActions.loadInvoice,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentCollection);



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/index.js